namespace pixi_ui.component {
    export class Visibility implements IComponent {
        public hidden: boolean;

        constructor(hidden: boolean) {
            this.hidden = hidden;
        }

        public attach(element: Element): void {
            element.visible = this.hidden;
        }

        public detach(element: Element): void {
            element.visible = true;
        }

        public resize(element: Element): void {}
    }
}
